import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.section`
	text-align: center;

	h2 {
		color: #FF9C46;
		color: var(--purple);
		margin: 20px;
	}

	.view-all {
		color: #ffaa66;
		color: var(--orange-light);
	}
`;

const Cards = styled.div`
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	padding-left: 10vw;
	padding-right: 10vw;

	> * {
		max-width: 30%;
		min-width: 200px;
	}

	@supports (display: grid) {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(200px, auto));
		grid-gap: 30px;
		padding-left: 0;
		padding-right: 0;
		margin: 0 10vw;
		margin: 0 var(--side-margin);

		> * {
			max-width: unset;
			min-width: unset;
		}
	}
`;

const SectionImages = ({ title, link, children }) => {
	return (
		<Container>
			{title && <h2>{title}</h2>}
			<Cards>{children}</Cards>
			{link && (
				<a
					className="view-all"
					href={link}
					target="_blank"
					rel="noopener noreferrer"
				>
					View all
				</a>
			)}
		</Container>
	);
};

SectionImages.propTypes = {
	title: PropTypes.string,
	children: PropTypes.node.isRequired,
	link: PropTypes.string
};

export default SectionImages;



// WEBPACK FOOTER //
// ./src/components/SectionImages.js